import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { ClipboardModule } from 'ngx-clipboard';
import { WarningDialogComponent } from './warning-dialog.component';

@NgModule({
  declarations: [
    WarningDialogComponent
  ],
  exports: [
    WarningDialogComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MatInputModule,
    MatIconModule,
    MatDividerModule,
    ClipboardModule
  ]
})
export class WarningDialogModule { }
